// IMPORTANT: disabling eslint rules at the file is not recommended.
// this file is an exception because useParallel is an experimental function that uses dynamic code (but is at least isolated to this file)

import { useRef } from "react";

/* eslint-disable react-compiler/react-compiler */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/only-throw-error */

export function useParallel<R1>(func1: (...args: any[]) => R1): [R1];
export function useParallel<R1, R2>(
    func1: (...args: any[]) => R1,
    func2: (...args: any[]) => R2
): [R1, R2];
export function useParallel<R1, R2, R3>(
    func1: (...args: any[]) => R1,
    func2: (...args: any[]) => R2,
    func3: (...args: any[]) => R3
): [R1, R2, R3];
export function useParallel<R1, R2, R3, R4>(
    func1: (...args: any[]) => R1,
    func2: (...args: any[]) => R2,
    func3: (...args: any[]) => R3,
    func4: (...args: any[]) => R4
): [R1, R2, R3, R4];
export function useParallel<R1, R2, R3, R4, R5>(
    func1: (...args: any[]) => R1,
    func2: (...args: any[]) => R2,
    func3: (...args: any[]) => R3,
    func4: (...args: any[]) => R4,
    func5: (...args: any[]) => R5
): [R1, R2, R3, R4, R5];
/** Run each function and collect all thrown promises (Suspense). Will throw a combined `any` promise so that React will retry as soon as any new data is available.
 *  This will ensure that all waterfalls are executed as soon as possible.
 */
export function useParallel(...funcs: ((...args: any) => any)[]): any[] {
    "use no memo";

    const hasEverFinishedRef = useRef(false);

    const promises: Promise<void>[] = [];
    const results: any[] = [];

    for (const func of funcs) {
        try {
            const result = func();
            results.push(result);
        } catch (error) {
            // if this hook has previously finished, catching promises will cause the order of hooks to change
            // (eg a subsequent func will run sooner than it did last time)
            if (isPromise(error) && !hasEverFinishedRef.current) {
                promises.push(error);
            } else {
                throw error;
            }
        }
    }

    if (promises.length === 1) {
        throw promises[0];
    }

    if (promises.length > 1) {
        throw Promise.any(promises);
    }

    hasEverFinishedRef.current = true;

    return results;
}

function isPromise(x: unknown): x is Promise<void> {
    return (
        !!x &&
        typeof x === "object" &&
        "then" in x &&
        typeof x.then === "function"
    );
}
